import { CustomLocale } from "flatpickr/dist/types/locale";
import dayjs from "dayjs";
import "@/utils/dayjsLocales";
import { German } from "flatpickr/dist/l10n/de.js";
import { Spanish } from "flatpickr/dist/l10n/es.js";
import { French } from "flatpickr/dist/l10n/fr.js";
import { Italian } from "flatpickr/dist/l10n/it.js";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
import { Korean } from "flatpickr/dist/l10n/ko.js";
import { Dutch } from "flatpickr/dist/l10n/nl.js";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import { Mandarin } from "flatpickr/dist/l10n/zh.js";
import { Polish } from "flatpickr/dist/l10n/pl.js";
import { Swedish } from "flatpickr/dist/l10n/sv.js";

import { normalizeLocale } from "@/utils/locale";

import { DateType } from "./types";
import { LanguageCode } from "@/types/languages";

export const formatDate = (
  type: DateType,
  selectedDate: Date,
  format: string,
  dates: Date[],
  locale?: LanguageCode
) => {
  if (!dates || dates.length === 0) return "";
  const dayjsLocale = locale ? normalizeLocale(locale) : "en";

  switch (type) {
    case "multiple":
    case "single": {
      const formattedDate = dayjs(selectedDate).locale(dayjsLocale).format(format);
      return formattedDate;
    }
    case "range": {
      const initFormattedDate = dayjs(dates[0]).locale(dayjsLocale).format(format);
      const endFormattedDate = dayjs(dates[1]).locale(dayjsLocale).format(format);

      const formattedDate = dates[1]
        ? `${initFormattedDate} - ${endFormattedDate}`
        : initFormattedDate;

      return formattedDate;
    }
  }
};

const flatpickrLocales: Partial<Record<LanguageCode, CustomLocale>> = {
  "de-DE": German,
  "es-ES": Spanish,
  "fr-FR": French,
  "it-IT": Italian,
  "ja-JP": Japanese,
  "ko-KR": Korean,
  "nl-NL": Dutch,
  "pt-BR": Portuguese,
  "zh-TW": Mandarin,
  "pl-PL": Polish,
  "sv-SE": Swedish,
};

export const getFlatpickrLocale = (locale: LanguageCode | undefined) => {
  return locale ? flatpickrLocales[locale] : undefined;
};
